<div class="max-w-5xl mx-auto p-4 md:p-10 bg-white font-['Hind_Siliguri']">
  
  <div class="text-center mb-10">
    <h2 class="text-3xl font-bold text-[#1e266d] inline-block relative px-2">
      সাপোর্ট সংক্রান্ত জিজ্ঞাসা (FAQ)
      <div class="absolute -bottom-1 left-0 w-full h-1 bg-orange-400 rounded-full"></div>
    </h2>
  </div>

  <div class="flex flex-col gap-4">
    @for (item of faqs; track item.id) {
      <div class="border-2 border-[#1e266d] rounded-md bg-white transition-all duration-300">
        
        <button 
          (click)="toggleFaq(item.id)"
          class="w-full flex items-center justify-between p-4 text-left focus:outline-none group">
          <span class="text-[17px] font-bold text-[#1e266d] group-hover:text-indigo-800">
            {{ item.question }}
          </span>
          
          <div class="text-[#1e266d] text-lg w-6 text-center">
            @if (activeId() === item.id) {
              <i class="fa-solid fa-minus"></i>
            } @else {
              <i class="fa-solid fa-plus"></i>
            }
          </div>
        </button>

        @if (activeId() === item.id) {
          <div class="p-5 pt-0 text-gray-800 border-t border-gray-100 animate-fade-in">
            <div class="mt-4">
              <ul class="space-y-3 list-none">
                @for (line of item.answers; track $index) {
                  <li class="leading-relaxed flex gap-3">
                    @if (item.answers.length > 1) {
                      <span class="text-[#1e266d] font-bold">•</span>
                    }
                    <span class="font-medium text-[16px]">{{ line }}</span>
                  </li>
                }
              </ul>
              
              @if (item.link) {
                <div class="mt-3">
                  <a [href]="item.link" target="_blank" class="text-pink-600 font-bold hover:underline italic break-all">
                    {{ item.link }}
                  </a>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>